module.exports = __webpack_public_path__ + "9d55aa573b07d9ac4a3c6d0fb8d7d847.svg";